import {
  ComponentMap,
  AustracEmail,
  AustracEmailFormModel,
} from '@/editor-map/types';
import { objPathToTitle } from '@/editor-map/title';

const editorType = 'austrac.ifti-dra.Email';
const title = objPathToTitle;

// eslint-disable-next-line @typescript-eslint/ban-types
export function toFormSchema(data: AustracEmail, readonly = false): object {
  return {
    elements: {
      email: {
        label: 'Email',
        type: 'text',
        maxLength: 250,
        pattern: '[^@]+@[^@]+',
        required: true,
        placeholder: 'Empty value',
        readonly,
      },
    },
  };
}

export function fromFormModel(formModel: AustracEmailFormModel): AustracEmail {
  return formModel.email;
}

export function toFormModel(data: AustracEmail): AustracEmailFormModel {
  return { email: data };
}

export const componentMap: ComponentMap = {
  [editorType]: {
    title,
    toFormModel,
    fromFormModel,
    toFormSchema,
  },
};

export default componentMap;
